
@if (isLoading$ | async) {
    <app-loading-indicator></app-loading-indicator>
} @else {
    @if ((secontTaskList$ | async)?.length === 0) {
        <app-card [noMargin]="true" [showHeader]="false">
            <div card-body class="table-empty-state h-auto mb-5">
                <img id="img-empty-tasks" class="empty" alt="Empty" src="/assets/img/empty-tasks.svg" />
                @if (isAsap) {
                    <h2>No ASAP Reports to Display</h2>
                    <p>
                        Any incomplete reports will appear here 
                        <br />
                        until finished and submitted.
                    </p>
                } @else {
                    <h2>No Tasks to Display</h2>
                    <p>
                        Try adjusting your applied filters to view 
                        <br />
                        tasks that need your attention.
                    </p>
                }
            </div>
        </app-card>
    } @else {
        <div class="flights-list-wrapper">
            @for (task of secontTaskList$ | async; track task.data._id; let index = $index) {
                @switch (task.type) {
                    @case ("flight") {
                        <app-home-task-card
                            [flight]="task.data"
                            [showEdit]="false"
                            [isLast]="index + 1 === (secontTaskList$ | async)?.length">
                        </app-home-task-card>
                    }
                    @case ("promotion") {
                        <app-promotion-task-card
                            [promotion]="task.data"
                            [isLast]="index + 1 === (secontTaskList$ | async)?.length">
                        </app-promotion-task-card>
                    }
                    @case ("issue") {
                        <app-issue-task-card
                            [issue]="task.data"
                            [isLast]="index + 1 === (secontTaskList$ | async)?.length">
                        </app-issue-task-card>
                    }
                    @case ("task") {
                        <app-task-card
                            [task]="task.data"
                            [showEdit]="false"
                            [isLast]="index + 1 === (secontTaskList$ | async)?.length">
                        </app-task-card>
                    }
                    @case ("audit") {
                        <app-audit-task-card
                            [audit]="task.data"
                            [isLast]="index + 1 === (secontTaskList$ | async)?.length">
                        </app-audit-task-card>
                    }
                    @case ("riskEvaluation") {
                        <app-risk-evaluation-task-card
                            [riskEvaluation]="task.data"
                            [isLast]="index + 1 === (secontTaskList$ | async)?.length">
                        </app-risk-evaluation-task-card>
                    }
                }
            }
        </div>

        @if (total > pageSize) {
            <p-paginator
                (onPageChange)="onPageChange($event)"
                [first]="currentPage * pageSize"
                [rows]="pageSize"
                [totalRecords]="total"
                [showCurrentPageReport]="false"
                [showPageLinks]="false"
                [showJumpToPageDropdown]="true">
            </p-paginator>
        }
    }
}
